// This file is just a redirect to App.jsx
import App from './App.jsx';
export default App; 